import { render, staticRenderFns } from "./AppData.vue?vue&type=template&id=d0a34f50&scoped=true&"
import script from "./AppData.vue?vue&type=script&lang=js&"
export * from "./AppData.vue?vue&type=script&lang=js&"
import style0 from "./AppData.vue?vue&type=style&index=0&id=d0a34f50&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a34f50",
  null
  
)

export default component.exports